import React from "react";
import { Tooltip, Alert } from "antd";
import { Box, LinearProgress } from "@mui/material";
import styles from "./TabelaDocOSObrigatorio.module.css";

import { FiDownload } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";

export default function TabelaDocOSObrigatorio({
  loadingDocumentos,
  paginatedData,
  loadings,
  info,
  FloatButtonVisualizar,
  FloatButtonDelete,
  handleVisualizarArquivo,
  downloadDocumento,
  showModal,
  dados,
}) {
  const temArquivos = Array.isArray(paginatedData) && paginatedData.length > 0;

  return (
    <div>
      {loadingDocumentos ? (
        <Box className={styles.carregando}>
          <LinearProgress />
        </Box>
      ) : temArquivos ? (
        <div className={styles.lista}>
          {paginatedData.map((file, index) => {
            const fileName = file.split(/[/\\]/).pop();
            const nomeEtapa = fileName.split(".").slice(0, -1).join("."); // Remove a extensão (.pdf, .png etc)

            const nomeExibicao =
              nomeEtapa === "FCPJ-RedeSim" ? "JCPS RedeSim" : nomeEtapa ||
              nomeEtapa === "Viabilidade-prefeitura" ? "Viabilidade da Prefeitura" : nomeEtapa
            
            const situacaoId = dados.situacao?.id;
            const ehViabilidade = nomeEtapa === "Viabilidade-prefeitura";
            const ehFCPSRedeSim = nomeEtapa === "FCPJ-RedeSim";
            const ehDesenquadramentoMEI = nomeEtapa === "Desenquadramento-mei";
            const ehFCN = nomeEtapa === "Ficha-Cadastral-Nacional";




            return (
              <div key={index} className={styles.linhaArquivo}>
                <div className={styles.nomeArquivo}>
                  <IoDocumentTextOutline /> {fileName}
                </div>

                <div className={styles.botoes}>
                  {file.nome?.toLowerCase().endsWith(".json") && (
                    <Tooltip title="Visualizar">
                      <div className={styles.botaoAcao} onClick={() => handleVisualizarArquivo(file)}>
                        <FloatButtonVisualizar />
                      </div>
                    </Tooltip>
                  )}

                  <Tooltip title="Download">
                    <div
                      loading={loadings[index]}
                      className={styles.botaoAcao}
                      onClick={() => downloadDocumento(info.id, fileName)}
                    >
                      <FiDownload />
                    </div>
                  </Tooltip>

                  {
                    // Agrupamos todas as condições que devem ESCONDER o botão (retornar null)
                    (ehViabilidade && situacaoId !== "V-CCM") ||
                    (ehFCPSRedeSim && situacaoId !== "A-RFB") ||
                    (ehDesenquadramentoMEI && situacaoId !== "M-TE") ||
                    (["Procuracao-ECAC", "Termo-de-regime-tributario", "Inscricao-estadual"].includes(nomeEtapa) &&
                      situacaoId !== "A-JCM") ||
                    (["inscricao-municipal"].includes(nomeEtapa) && situacaoId !== "A-CCM") ||
                    (ehFCN && situacaoId !== "A-RFB") ? null : ( // Se qualquer uma das regras acima for verdadeira, esconde o botão
                      <Tooltip title="Excluir">
                        <div className={styles.botaoExcluir} onClick={() => showModal(file)}>
                          <FloatButtonDelete />
                        </div>
                      </Tooltip>
                    )
                  }
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className={styles.avisoVazio}>
          <Alert message="Nenhum documento disponível." type="info" showIcon />
        </div>
      )}
    </div>
  );
}
